<div class="filterWrapper" id="openFIlterMenu">
  <div class="row">
    <div class="col-12">
      <span class="filterHeading mb-3"> {{ "Quick" | translate }} {{ "Filter" | translate }} </span>
      <div class="kit-btn-group mt-3">
        <span class="d-inline-block mr-2 font-12">
          <ng-container *ngFor="let filter of quickFilterArr">
            <button class="btn btn-first font-13 mr-2 t-b-show" (click)="implimentFilter(filter)" [style.background-color]="filterService.lightenColor(filter.filtertheme, 0.2)" [style.color]="filterService.getcoloOfTheme(filter.filtertheme)">
              {{ filter.filterName }}
              <i class="fas fa-trash-alt ml-2 t-b-hide" id="openFIlterMenu" (click)="removeQuickFilter(filter); stopPropagation($event)"></i>
            </button>
          </ng-container>
        </span>
        <span class="material-icons cursor-p" *ngIf="compName == 'reports' || compName == 'reportResource'" (click)="showCronModal('Booking Resources')" data-toggle="modal" data-target="#modalAutomation" style="position: relative; margin-left: 15px; float: right"> manage_history </span>
      </div>

      <mat-divider class="mt-3 mb-3"></mat-divider>

      <ng-container *ngFor="let filter of filterService.selectedFilterArr; let i = index">
        <!---added by saurabh singh-->

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'MediaSupport' && compName == 'media'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearMediaSupport()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="mediaSupportList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="mediaSupportList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchMedia" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let mediaS of mediaSupportList | globalSearch : searchMedia">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterSupportMedia-{{ mediaS.name }}" [(ngModel)]="mediaS.checked" (click)="mediaSupportCheckbox(mediaS)" />
                  <label for="dynamicFilterSupportMedia-{{ mediaS.name }}" class="chk"></label>
                  <label for="dynamicFilterSupportMedia-{{ mediaS.name }}">{{ mediaS.name }}</label>
                </div>
              </li>
            </ul>
          </div>

          <!-- Filter Button with Selected Count -->
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedmediaSupportBoxList.length != 0">
              {{ selectedmediaSupportBoxList.length }}
            </span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'MediaFormat' && compName == 'media'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearMediaSupport()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="mediaFormateData.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="mediaFormateData.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchMedia" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let mediaF of mediaFormateData | globalSearch : searchMedia">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterSupportMedia-{{ mediaF.name }}" [(ngModel)]="mediaF.checked" (click)="mediaFormatCheckbox(mediaF)" />
                  <label for="dynamicFilterSupportMedia-{{ mediaF.name }}" class="chk"></label>
                  <label for="dynamicFilterSupportMedia-{{ mediaF.name }}">{{ mediaF.name }}</label>
                </div>
              </li>
            </ul>
          </div>

          <!-- Filter Button with Selected Count -->
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedMediaFormtBoxList.length != 0">
              {{ selectedMediaFormtBoxList.length }}
            </span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Business Unit'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearBUFilter()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="companyList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="companyList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchBu" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let comp of companyList | globalSearch : searchBu; let groupIndex = index">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ comp.name }}" [(ngModel)]="comp.checked" (click)="filterBU(comp)" />
                  <label for="dynamicFilter-{{ comp.name }}" class="chk"></label>
                  <label for="dynamicFilter-{{ comp.name }}">{{ comp.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedBuList.length != 0">{{ selectedBuList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Function' && (compName == 'equipment' || compName == 'reportResource')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearEqupFunction()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="equipmentFunctionCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="equipmentFunctionCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="euipFnSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let equpFn of equipmentFunctionCheckBoxList | sortAlpha : 'qualifiedName' | globalSearch : euipFnSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterFnEquip-{{ equpFn.value }}" [(ngModel)]="equpFn.checked" (click)="equipCheckbox(equpFn)" />
                  <label for="dynamicFilterFnEquip-{{ equpFn.value }}" class="chk"></label>
                  <label for="dynamicFilterFnEquip-{{ equpFn.value }}">{{ equpFn.qualifiedName }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedEquipFunctionCheckBoxList.length != 0">{{ selectedEquipFunctionCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Model' && compName == 'equipment'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearModalEquipment()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="modelCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="modelCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="euipModalSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let equpModal of modelCheckBoxList | sortAlpha : 'label' | globalSearch : euipModalSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterequpModal-{{ equpModal.label }}" [(ngModel)]="equpModal.checked" (click)="addSelectedModelCheckbox(equpModal)" />
                  <label for="dynamicFilterequpModal-{{ equpModal.label }}" class="chk"></label>
                  <label for="dynamicFilterequpModal-{{ equpModal.label }}">{{ equpModal.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedModelCheckBoxList.length != 0">{{ selectedModelCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Location' && compName == 'equipment'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearLocationEquip()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="locationCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="locationCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="equipLocSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let equpLoc of locationCheckBoxList | sortAlpha : 'value' | globalSearch : equipLocSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterLocEquip-{{ equpLoc.label }}" [(ngModel)]="equpLoc.checked" (click)="addSelectedLocationCheckbox(equpLoc)" />
                  <label for="dynamicFilterLocEquip-{{ equpLoc.label }}" class="chk"></label>
                  <label for="dynamicFilterLocEquip-{{ equpLoc.label }}">{{ equpLoc.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedLocationCheckBoxList.length != 0">{{ selectedLocationCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Type' && compName == 'equipment'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearTypeEquip()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="equipmentTypeCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="equipmentTypeCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="equipTypeSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let equpType of equipmentTypeCheckBoxList | sortAlpha : 'value' | globalSearch : equipTypeSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterTypeEquip-{{ equpType.label }}" [(ngModel)]="equpType.checked" (click)="addEquipmentTypeCheckBox(equpType)" />
                  <label for="dynamicFilterTypeEquip-{{ equpType.label }}" class="chk"></label>
                  <label for="dynamicFilterTypeEquip-{{ equpType.label }}">{{ equpType.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedEquipmentTypeCheckBoxList.length != 0">{{ selectedEquipmentTypeCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Active' && (compName == 'equipment' || compName == 'personal')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearActive()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li *ngFor="let act of bookedCheckBoxList">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterActEquip-{{ act.label }}" [(ngModel)]="act.checked" (click)="addSelectedBookedCheckbox1(act)" />
                  <label for="dynamicFilterActEquip-{{ act.label }}" class="chk"></label>
                  <label for="dynamicFilterActEquip-{{ act.label }}">{{ act.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedBookedCheckBoxList1.length != 0">{{ selectedBookedCheckBoxList1.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'UserType' && (compName == 'equipment' || compName == 'personal' || compName == 'userAccount')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearUserType()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li *ngFor="let act of userTypeCheckBoxList">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterUserType-{{ act.label }}" [(ngModel)]="act.checked" (click)="addSelectedUserType(act)" />
                  <label for="dynamicFilterUserType-{{ act.label }}" class="chk"></label>
                  <label for="dynamicFilterUserType-{{ act.label }}">{{ act.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ "Access" | translate }}
            <span *ngIf="selectedUserType.length != 0">{{ selectedUserType.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'License' && compName == 'userAccount'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearPersonalType()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li *ngFor="let act of personalTypeCheckBoxList">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterPersonalType-{{ act.label }}" [(ngModel)]="act.checked" (click)="addSelectedPersonalType(act)" />
                  <label for="dynamicFilterPersonalType-{{ act.label }}" class="chk"></label>
                  <label for="dynamicFilterPersonalType-{{ act.label }}">{{ act.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ "User Type" | translate }}
            <span *ngIf="selectedPersonalType.length != 0">{{ selectedPersonalType.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Actualized' && compName == 'schedule' && !hiddenFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearActual()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li *ngFor="let act of actualArr">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterActual-{{ act.label }}" [(ngModel)]="act.checked" (click)="addSelectedActualCheckbox(act)" />
                  <label for="dynamicFilterActual-{{ act.label }}" class="chk"></label>
                  <label for="dynamicFilterActual-{{ act.label }}">{{ act.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedActualCheckBoxList.length != 0">{{ selectedActualCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Function' && (compName == 'personal' || compName == 'reports')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearFunctionPersonal()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="personalFunctionCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="personalFunctionCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="perFnSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let perFn of personalFunctionCheckBoxList | sortAlpha : 'qualifiedName' | globalSearch : perFnSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterperFn-{{ perFn.qualifiedName }}" [(ngModel)]="perFn.checked" (click)="personalCheckbox(perFn)" />
                  <label for="dynamicFilterperFn-{{ perFn.qualifiedName }}" class="chk"></label>
                  <label for="dynamicFilterperFn-{{ perFn.qualifiedName }}">{{ perFn.qualifiedName }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedPerFunctionCheckBoxList.length != 0">{{ selectedPerFunctionCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Skill' && compName == 'personal'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearSkillPersonal()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="skillsCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="skillsCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="skillSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let skill of skillsCheckBoxList">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterperdkill-{{ skill.label }}" [(ngModel)]="skill.checked" (click)="addSelectedSkillCheckbox(skill)" />
                  <label for="dynamicFilterperdkill-{{ skill.label }}" class="chk"></label>
                  <label for="dynamicFilterperdkill-{{ skill.label }}">{{ skill.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedSkillCheckBoxList.length != 0">{{ selectedSkillCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Personal Type' && (compName == 'personal' || compName == 'reports')">
          <div class="dropDownFilter" style="height: 60vh !important; left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearTypePersonaal()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>

            <ng-container *ngFor="let free of freelancerCheckBoxList">
              <ul>
                <div class="checkbox mt-2">
                  <input type="checkbox" id="dynamicFilterperfreeP-{{ free.contractname }}" [(ngModel)]="free.checked" (click)="selectListAll(free)" />
                  <label for="dynamicFilterperfreeP-{{ free.contractname }}" class="chk"></label>
                  <label for="dynamicFilterperfreeP-{{ free.contractname }}">{{ free.contractname | translate }}</label>
                </div>

                <li *ngFor="let list of free.listValues" style="margin-left: 30px">
                  <div class="checkbox">
                    <input type="checkbox" id="dynamicFilterperfree-{{ list.listValue }}" [(ngModel)]="list.checked" (click)="addSelectedFreelanceCheckbox(free, list)" />
                    <label for="dynamicFilterperfree-{{ list.listValue }}" class="chk"></label>
                    <label for="dynamicFilterperfree-{{ list.listValue }}">{{ list.listValue }}</label>
                  </div>
                </li>
              </ul>
              <mat-divider></mat-divider>
            </ng-container>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedContractArr.length != 0">{{ selectedContractArr.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Location' && compName == 'personal'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearLocationPersonal()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="perLocationCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="perLocationCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="perLocSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>

              <li *ngFor="let perLoc of perLocationCheckBoxList | globalSearch : perLocSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterperLoc-{{ perLoc.label }}" [(ngModel)]="perLoc.checked" (click)="addSelectedLocationPerCheckbox(perLoc)" />
                  <label for="dynamicFilterperLoc-{{ perLoc.label }}" class="chk"></label>
                  <label for="dynamicFilterperLoc-{{ perLoc.label }}">{{ perLoc.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedLocationPerCheckBoxList.length != 0">{{ selectedLocationPerCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Group' && compName == 'personal'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearGroupPersonal()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="groupCheckBoxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="groupCheckBoxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="groupSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>

              <li *ngFor="let pergroup of groupCheckBoxList | globalSearch : groupSearch">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterpergroup-{{ pergroup.label }}" [(ngModel)]="pergroup.checked" (click)="groupCheckbox(perLoc)" />
                  <label for="dynamicFilterpergroup-{{ pergroup.label }}" class="chk"></label>
                  <label for="dynamicFilterpergroup-{{ pergroup.label }}">{{ pergroup.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedGroupCheckBoxList.length != 0">{{ selectedGroupCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Category' && compName == 'client'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearCategoryCLient()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="dropdownIndex = -1" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="categoryCheckBoxListClient.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="categoryCheckBoxListClient.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="clientCatSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>

              <li *ngFor="let cilentCat of categoryCheckBoxListClient | globalSearch : clientCatSearch | sortAlpha : 'label'">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFiltercilentCat-{{ cilentCat.label }}" [(ngModel)]="cilentCat.checked" (click)="filterClientCategory(cilentCat)" />
                  <label for="dynamicFiltercilentCat-{{ cilentCat.label }}" class="chk"></label>
                  <label for="dynamicFiltercilentCat-{{ cilentCat.label }}">{{ cilentCat.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedDomainCheckBoxList.length != 0">{{ selectedDomainCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'City' && compName == 'client'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearCityCLient()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="locationCheckBoxListClient.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="locationCheckBoxListClient.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="clientLocSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>

              <li *ngFor="let cilentLoc of locationCheckBoxListClient | globalSearch : clientLocSearch | sortAlpha : 'label'">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFiltercilentLoc-{{ cilentLoc.label }}" [(ngModel)]="cilentLoc.checked" (click)="filterClientLocation(cilentLoc)" />
                  <label for="dynamicFiltercilentLoc-{{ cilentLoc.label }}" class="chk"></label>
                  <label for="dynamicFiltercilentLoc-{{ cilentLoc.label }}">{{ cilentLoc.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedCityCheckBoxList.length != 0">{{ selectedCityCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Country' && compName == 'client'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearCountryClient()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="countryCheckBoxListCLient.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="countryCheckBoxListCLient.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="clientConSearch" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>

              <li *ngFor="let cilentCon of countryCheckBoxListCLient | globalSearch : clientConSearch | sortAlpha : 'label'">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFiltercilentCon-{{ cilentCon.label }}" [(ngModel)]="cilentCon.checked" (click)="filterClientCountry(cilentCon)" />
                  <label for="dynamicFiltercilentCon-{{ cilentCon.label }}" class="chk"></label>
                  <label for="dynamicFiltercilentCon-{{ cilentCon.label }}">{{ cilentCon.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedCountryCheckBoxListClient.length != 0">{{ selectedCountryCheckBoxListClient.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Project' && (compName == 'show' || compName == 'schedule' || compName == 'board' || compName == 'reports' || compName == 'reportResource' || compName == 'asset' || compName == 'media' || compName == 'taskView')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearScheduleProject()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="projectArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="projectArr.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchProject" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let proj of projectArr | sortAlpha : 'projectname' | globalSearch : searchProject">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ proj.title }}" [(ngModel)]="proj.checked" (click)="filterProject(proj)" />
                  <label for="dynamicFilter-{{ proj.title }}" class="chk"></label>
                  <label for="dynamicFilter-{{ proj.title }}">{{ proj.title }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedProjectCheckBoxList.length != 0">{{ selectedProjectCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Channel' && compName == 'show'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearNetwork()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="networkList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="networkList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchNetwork" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let net of networkList | sortAlpha : 'name' | globalSearch : searchNetwork">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ net.name }}" [(ngModel)]="net.checked" (click)="filterNetwork(net)" />
                  <label for="dynamicFilter-{{ net.name }}" class="chk"></label>
                  <label for="dynamicFilter-{{ net.name }}">{{ net.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedNetworkCheckBoxList.length != 0">{{ selectedNetworkCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Pool' && (compName == 'reports' || compName == 'reportResource')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearKit()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="kitArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="kitArr.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchKit" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let kit of kitArr | sortAlpha : 'name' | globalSearch : searchKit">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterKit-{{ kit.name }}" [(ngModel)]="kit.checked" (click)="filterKit(kit)" />
                  <label for="dynamicFilterKit-{{ kit.name }}" class="chk"></label>
                  <label for="dynamicFilterKit-{{ kit.name }}">{{ kit.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedKitCheckBoxList.length != 0">{{ selectedKitCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Client' && (compName == 'show' || compName == 'schedule' || compName == 'board' || compName == 'reports' || compName == 'reportResource' || compName == 'asset' || compName == 'media')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearScheduleClient()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="clientArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="clientArr.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchClient" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let client of clientArr | sortAlpha : 'name' | globalSearch : searchClient">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ client.name }}" [(ngModel)]="client.checked" (click)="filterClientCheckbox(client)" />
                  <label for="dynamicFilter-{{ client.name }}" class="chk"></label>
                  <label for="dynamicFilter-{{ client.name }}">{{ client.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedclientCheckBoxList.length != 0">{{ selectedclientCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Phase' && (compName == 'reports' || compName == 'reportResource')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearPlanning()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="planningEventStatusList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="planningEventStatusList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchPlanningStatus" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let planning of planningEventStatusList | sortAlpha : 'statusName' | globalSearch : searchPlanningStatus">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ planning.statusName }}" [(ngModel)]="planning.checked" (click)="filterPlanningCheckbox(planning)" />
                  <label for="dynamicFilter-{{ planning.statusName }}" class="chk"></label>
                  <label for="dynamicFilter-{{ planning.statusName }}">{{ planning.statusName }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedPlanningCheckBoxList.length != 0">{{ selectedPlanningCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Project Owner' && (compName == 'show' || compName == 'schedule' || compName == 'board') && !hiddenFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearProjectOwner()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="projectOwnerCheckboxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="projectOwnerCheckboxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchPOwner" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let person of projectOwnerCheckboxList | sortAlpha : 'fullName' | globalSearch : searchPOwner">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterPO-{{ person.fullName }}" [(ngModel)]="person.checked" (click)="filterProjectOwner(person)" />
                  <label for="dynamicFilterPO-{{ person.fullName }}" class="chk"></label>
                  <label for="dynamicFilterPO-{{ person.fullName }}">{{ person.fullName }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedProjectOwnerList.length != 0">{{ selectedProjectOwnerList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Phase Owner' && (compName == 'show' || compName == 'schedule' || compName == 'board' || compName == 'reports' || compName == 'reportResource') && !hidePhasemanagerFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearPhaseOwner()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="phaseManagerCheckboxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="phaseManagerCheckboxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchPhManager" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let person of phaseManagerCheckboxList | sortAlpha : 'fullName' | globalSearch : searchPhManager">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterPH-{{ person.fullName }}" [(ngModel)]="person.checked" (click)="filterPhaseManager(person)" />
                  <label for="dynamicFilterPH-{{ person.fullName }}" class="chk"></label>
                  <label for="dynamicFilterPH-{{ person.fullName }}">{{ person.fullName }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedPhaseList.length != 0">{{ selectedPhaseList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Account Manager' && (compName == 'show' || compName == 'schedule' || compName == 'board' || compName == 'reports' || compName == 'reportResource') && !hiddenFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearAccountManager()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="accountManagerCheckboxList.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="accountManagerCheckboxList.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchAccountManager" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let person of accountManagerCheckboxList | sortAlpha : 'fullName' | globalSearch : searchAccountManager">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilterAM-{{ person.fullName }}" [(ngModel)]="person.checked" (click)="filterAccountManager(person)" />
                  <label for="dynamicFilterAM-{{ person.fullName }}" class="chk"></label>
                  <label for="dynamicFilterAM-{{ person.fullName }}">{{ person.fullName }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedAccountManagerList.length != 0">{{ selectedAccountManagerList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Country' && (compName == 'schedule' || compName == 'board' || compName == 'reports' || compName == 'reportResource') && !hiddenFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearCountrySchedule()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>

            <ul>
              <li style="font-size: 16px" *ngIf="countryArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="countryArr.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchCountry" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let country of countryArr | sortAlpha : 'name' | globalSearch : searchCountry">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ country.name }}" [(ngModel)]="country.checked" (click)="filterCountryCheckbox(country)" />
                  <label for="dynamicFilter-{{ country.name }}" class="chk"></label>
                  <label for="dynamicFilter-{{ country.name }}">{{ country.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedCountryCheckBoxList.length != 0">{{ selectedCountryCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Region' && (compName == 'schedule' || compName == 'board') && !hiddenFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearRegionSchedule()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="regionArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="regionArr.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchRegion" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let region of regionArr | sortAlpha : 'name' | globalSearch : searchRegion">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ region.name }}" [(ngModel)]="region.checked" (click)="filterRegionCheckbox(region)" />
                  <label for="dynamicFilter-{{ region.name }}" class="chk"></label>
                  <label for="dynamicFilter-{{ region.name }}">{{ region.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedRegionCheckBoxList.length != 0">{{ selectedRegionCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Category' && (compName == 'schedule' || compName == 'board') && !hiddenFilter">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearCategorySchedule()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="categoryArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngIf="categoryArr.length > 8">
                <div class="input-group">
                  <div class="form-group w-100">
                    <input type="text" class="form-control modal-text-box" [(ngModel)]="searchCategory" placeholder="Search..." [attr.required]="true" />
                  </div>
                </div>
              </li>
              <li *ngFor="let cat of categoryArr | sortAlpha : 'name' | globalSearch : searchCategory">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ cat.name }}" [(ngModel)]="cat.checked" (click)="filterCategoryCheckbox(cat)" />
                  <label for="dynamicFilter-{{ cat.name }}" class="chk"></label>
                  <label for="dynamicFilter-{{ cat.name }}">{{ cat.name }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedCategoryCheckBoxList.length != 0">{{ selectedCategoryCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Export' && compName == 'reports'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearExport()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="exportArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngFor="let export of exportArr">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ export.label }}" [(ngModel)]="export.checked" (click)="filterExportCheckbox(export)" />
                  <label for="dynamicFilter-{{ export.label }}" class="chk"></label>
                  <label for="dynamicFilter-{{ export.label }}">{{ export.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedExportCheckBoxList.length != 0">{{ selectedExportCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Push To Financial' && compName == 'reports'">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearFinancail()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="financialArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngFor="let finan of financialArr">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ finan.label }}" [(ngModel)]="finan.checked" (click)="addSelectedFinancial(finan)" />
                  <label for="dynamicFilter-{{ finan.label }}" class="chk"></label>
                  <label for="dynamicFilter-{{ finan.label }}">{{ finan.label }}</label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            {{ filter | translate }}
            <span *ngIf="selectedFinancailCheckBoxList.length != 0">{{ selectedFinancailCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
        <!-- *ngIf="filter == 'Time Off' && compName == 'reports'" -->
        <div class="filterTags mb-3" id="filter-id" *ngIf="filter == 'Time Off' && (compName == 'reports' || compName == 'reportResource')">
          <div class="dropDownFilter" style="left: 0" [hidden]="!(dropdownIndex == i)">
            <button class="btn btn-first m-2" (click)="clearFinancail()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
              {{ "Clear" | translate }}
            </button>

            <button class="btn btn-first m-2" (click)="openDropDownModal(-1)" title="{{ 'Close' | translate }}" [style.background-color]="filterService.lightenColor('#cc3300', 0.2)" [style.color]="filterService.getcoloOfTheme('#cc3300')">&#10005;</button>
            <ul>
              <li style="font-size: 16px" *ngIf="timeOffArr.length == 0">
                <label
                  >{{ "List is empty" | translate }}
                  <i class="fa fa-frown-o ml-2" aria-hidden="true"></i>
                </label>
              </li>
              <li *ngFor="let timeOff of timeOffArr">
                <div class="checkbox">
                  <input type="checkbox" id="dynamicFilter-{{ timeOff.label }}" [(ngModel)]="timeOff.checked" (click)="addSelectedTimeOff(timeOff)" />
                  <label for="dynamicFilter-{{ timeOff.label }}" class="chk"></label>
                  <label for="dynamicFilter-{{ timeOff.label }}">
                    <ng-container *ngIf="compName == 'reports'">
                      {{ timeOff.label | translate }}
                    </ng-container>
                    <ng-container *ngIf="compName == 'reportResource'">
                      {{ "Maintenance" | translate }}
                    </ng-container>
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <button class="filterButtons" title="{{ 'Open Modal' }}" (click)="openDropDownModal(i)">
            <ng-container *ngIf="compName == 'reports'">
              {{ filter | translate }}
            </ng-container>
            <ng-container *ngIf="compName == 'reportResource'">
              {{ "Maintenance" | translate }}
            </ng-container>

            <span *ngIf="selectedTimeOffCheckBoxList.length != 0">{{ selectedTimeOffCheckBoxList.length }}</span>
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </button>
        </div>
      </ng-container>

      <div class="saveFilter mt-4" *ngIf="quickFilterFlag">
        <input type="text" style="width: 60%" class="form-control resource-search mb-3 d-inline-block" [(ngModel)]="quickFilterName" placeholder="{{ 'Filter ' }}{{ 'Name' }}" />
        <span class="colorbox" id="colorBox" (click)="colorbox = !colorbox" title="{{ 'Select Theme' | translate }}" [ngStyle]="{ color: selectedColor }">
          <i class="fa fa-square" aria-hidden="true"></i>
        </span>
        <div class="colorBoxDiv" *ngIf="colorbox" id="colorBox">
          <div class="theme-box" *ngFor="let color of divColor" (click)="updateTheme(color.color)" [ngStyle]="{ 'background-color': color.color }" title="{{ color.themeName }}&nbsp;{{ color.color }}"></div>
        </div>

        <button class="btn btn-first mr-2 font-14" id="openFIlterMenu" *ngIf="quickFilterName != null && quickFilterName != ''" style="float: right" (click)="saveQuickFIlter()">
          {{ "Save" | translate }}
        </button>
      </div>

      <div class="kit-btn-group mt-4 mb-3">
        <span class="d-inline-block mr-2 font-12">
          <button class="btn btn-first font-13 mr-2" [matMenuTriggerFor]="filterAddDropdownKit">
            <i class="fas fa-plus"></i>&nbsp; {{ "Add" | translate }} {{ "Filter" | translate }} &nbsp;
            <i class="fas fa-angle-down"></i>
          </button>
        </span>
      </div>
      <mat-menu #filterAddDropdownKit="matMenu">
        <ng-container *ngFor="let filterName of filterService.getfilterArr(compName)">
          <ng-container *ngIf="filterName == 'Business Unit'">
            <button mat-menu-item class="d-flex justify-content-between" id="openFIlterMenu" (click)="filterService.setDyanmicFilter(filterName)">
              <span class="wp-70">
                {{ filterName | translate }}
              </span>
              <span class="wp-30" *ngIf="this.filterService.checkFilterPresent(filterName)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="filterName == 'Phase Owner' && !hidePhasemanagerFilter">
            <button mat-menu-item class="d-flex justify-content-between" id="openFIlterMenu" (click)="filterService.setDyanmicFilter(filterName)">
              <span class="wp-70">
                {{ filterName | translate }}
              </span>
              <span class="wp-30" *ngIf="this.filterService.checkFilterPresent(filterName)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="filterName == 'UserType' && !hidePhasemanagerFilter">
            <button mat-menu-item class="d-flex justify-content-between" id="openFIlterMenu" (click)="filterService.setDyanmicFilter(filterName)">
              <span class="wp-70">
                {{ "Access" | translate }}
              </span>
              <span class="wp-30" *ngIf="this.filterService.checkFilterPresent(filterName)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="filterName == 'Time Off' && !hidePhasemanagerFilter">
            <button mat-menu-item class="d-flex justify-content-between" id="openFIlterMenu" (click)="filterService.setDyanmicFilter(filterName)">
              <span class="wp-70">
                <ng-container *ngIf="compName == 'reports'">
                  {{ filterName | translate }}
                </ng-container>
                <ng-container *ngIf="compName == 'reportResource'">
                  {{ "Maintenance" | translate }}
                </ng-container>
              </span>
              <span class="wp-30" *ngIf="this.filterService.checkFilterPresent(filterName)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="filterName != 'Business Unit' && filterName != 'Phase Owner' && filterName != 'Time Off' && filterName != 'UserType'">
            <button mat-menu-item class="d-flex justify-content-between" id="openFIlterMenu" (click)="filterService.setDyanmicFilter(filterName)">
              <span class="wp-70">
                {{ filterName | translate }}
              </span>
              <span class="wp-30" *ngIf="this.filterService.checkFilterPresent(filterName)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
            </button>
          </ng-container>
        </ng-container>
      </mat-menu>

      <mat-divider></mat-divider>
      <div class="kit-btn-group mt-3" style="width: 100%">
        <span class="d-inline-block mr-2 font-14" style="width: 100%">
          <button class="btn btn-first mr-2 font-14" id="openFIlterMenu" (click)="clearAllfilters()" [style.background-color]="filterService.lightenColor('#0091fb', 0.2)" [style.color]="filterService.getcoloOfTheme('#0091fb')">
            {{ "Clear" | translate }}
          </button>

          <button class="btn btn-first mr-2 font-14" style="float: right" (click)="applyFilters()">
            {{ "Apply" | translate }}
          </button>
        </span>
      </div>
    </div>
  </div>
</div>

<div id="modalAutomation" class="modal" *ngIf="cronModaLFlag" role="dialog">
  <form [formGroup]="cronForm">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header mb-1">
          <h4 class="modal-title font-league text-uppercase font-18 txt-light-gog">{{ "Set Automation" | translate }}</h4>
          <button type="button" (click)="cronModaLFlag = false" class="close font-14" data-dismiss="modal">&#10005;</button>
        </div>
        <div class="modal-body px-5">
          <mat-tab-group animationDuration="1000ms" mat-align-tabs="center" (selectedTabChange)="onTabChangedAuto($event)">
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>schedule</mat-icon>
                {{ "Minute" | translate }}
              </ng-template>
              <div class="row mx-0 mt-2 mb-1">
                <div class="input-row">
                  <div style="margin-left: 20px; margin-top: 10px">
                    <label class="radio-custom-label not-allowed" style="margin-top: 0px">
                      {{ "Every" | translate }}
                      <select id="cronHourIncrementIncrement" style="width: 50px" formControlName="MinuteEveryMinute">
                        <option value="{{ min }}" *ngFor="let min of cronMinuteArr">{{ min }}</option>
                      </select>
                      {{ "Minute" | translate }}
                    </label>
                  </div>
                  <div style="margin-left: 20px" class="">
                    <label class="radio-custom-label not-allowed"> Send <input style="width: 50px" type="number" maxlength="2" formControlName="reportDays" /> {{ "Day Report" | translate }} </label>
                  </div>
                  <div class="sentence-previewx">{{ "Every " | translate }} {{ cronForm.controls["MinuteEveryMinute"].value }} {{ "Minute," | translate }} {{ "send " }} {{ cronForm.controls["reportDays"].value }} {{ "day report. " }}</div>
                </div>
              </div>

              <div class="row mx-0 mt-2 mb-1">
                <div style="display: flex; position: fixed; gap: 4rem">
                  <div style="position: relative">
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="assignedGroup1" [ngModelOptions]="{ standalone: true }" (change)="getGroupSubStatus(assignedGroup1)" placeholder="{{ 'Recipient' | translate }}" list="personnal1" />

                    <div class="dropdown-parent" style="position: absolute; top: 0; right: 0">
                      <a href="javascript:void(0)" class="availableBtn txt-light-gog">
                        <i class="fas fa-chevron-down cursor-p ml-10" *ngIf="selectGroupArr1.length > 0" (click)="showMore1 = !showMore1"></i>
                      </a>

                      <div class="dropdown-panel bg-white-mode" *ngIf="showMore1 && selectGroupArr1.length > 0" style="width: 280px">
                        <ul class="list-unstyled mb-0">
                          <li *ngFor="let obj of selectGroupArr1" class="position-relative">
                            {{ obj }}
                            <span class="text-danger font-14 position-absolute" style="right: 8px; cursor: pointer" (click)="removeGroup1(obj); $event.stopPropagation()" title="{{ 'Delete' | translate }}"> &#10005; </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <datalist id="personnal1">
                      <option *ngFor="let item of productionGroupList | sortAlpha : 'name'" [value]="item.name">{{ item.name }}</option>
                    </datalist>
                  </div>

                  <!-- for select a filter from list-->
                  <div>
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="selectedQuickFilter" [ngModelOptions]="{ standalone: true }" (change)="onQuickFilterChange(selectedQuickFilter)" placeholder="{{ 'Quick Filter' | translate }}" list="quickFilterList" />
                    <datalist id="quickFilterList">
                      <option *ngFor="let filter of quickFilterArr" [value]="filter.filterName">{{ filter.filterName }}</option>
                    </datalist>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>today</mat-icon>
                {{ "Day" | translate }}
              </ng-template>
              <div class="row mx-0 mt-2 mb-1">
                <div class="input-row">
                  <div style="margin-left: 20px; margin-top: 10px">
                    <label class="radio-custom-label not-allowed" style="margin-top: 0px">
                      {{ "Every" | translate }}
                      <select id="cronHourIncrementIncrement" style="width: 50px" formControlName="DayEveryDay">
                        <option value="{{ day }}" *ngFor="let day of cronMonthsArr">{{ day }}</option>
                      </select>
                      {{ "day(s) at" | translate }}
                      <!-- add week days -->
                      <select id="SelecthourOnHOurbasis" formControlName="DayEveryStartTime" style="width: 100px">
                        <option value="{{ hour }}" *ngFor="let hour of twentyFourhourFormatArr">{{ hour }}</option>
                      </select>
                    </label>
                  </div>

                  <div style="margin-left: 20px" class="">
                    <label class="radio-custom-label not-allowed"> Send <input style="width: 50px" type="number" maxlength="2" formControlName="reportDays" /> {{ "Day Report" | translate }} </label>
                  </div>
                  <div class="sentence-previewx">
                    {{ "Every " | translate }} {{ cronForm.controls["DayEveryDay"].value }} {{ "day at" | translate }} {{ cronForm.controls["DayEveryStartTime"].value }} {{ "hours," | translate }} {{ "send " }} {{ cronForm.controls["reportDays"].value }} {{ "day report. " }}
                  </div>
                </div>
              </div>
              <div class="row mx-0 mt-2 mb-1">
                <div style="display: flex; position: fixed; gap: 4rem">
                  <div style="position: relative">
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="assignedGroup1" [ngModelOptions]="{ standalone: true }" (change)="getGroupSubStatus(assignedGroup1)" placeholder="{{ 'Recipient' | translate }}" list="personnal1" />
                    <div class="dropdown-parent" style="position: absolute; top: 0; right: 0">
                      <a href="javascript:void(0)" class="availableBtn txt-light-gog">
                        <i class="fas fa-chevron-down cursor-p ml-10" *ngIf="selectGroupArr1.length > 0" id="dropdown-id1" (click)="showMore1 = !showMore1"></i>
                      </a>
                      <div class="dropdown-panel bg-white-mode" *ngIf="showMore1 && selectGroupArr1.length > 0" style="width: 280px">
                        <ul class="list-unstyled mb-0">
                          <li *ngFor="let obj of selectGroupArr1" class="position-relative">
                            {{ obj }}
                            <span class="text-danger font-14 position-absolute" style="right: 8px; cursor: pointer" (click)="removeGroup1(obj); $event.stopPropagation()" title="{{ 'Delete' | translate }}"> &#10005; </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <datalist id="personnal1">
                      <option *ngFor="let item of productionGroupList | sortAlpha : 'name'" [value]="item.name">{{ item.name }}</option>
                    </datalist>
                  </div>
                  <div>
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="selectedQuickFilter" [ngModelOptions]="{ standalone: true }" (change)="onQuickFilterChange(selectedQuickFilter)" placeholder="{{ 'Quick Filter' | translate }}" list="quickFilterList" />
                    <datalist id="quickFilterList">
                      <option *ngFor="let filter of quickFilterArr" [value]="filter.filterName">{{ filter.filterName }}</option>
                    </datalist>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>view_week</mat-icon>
                {{ "Week" | translate }}
              </ng-template>
              <div class="row mx-3 mt-2 mb-1">
                <div class="input-row">
                  <div style="margin-left: 20px; margin-top: 10px">
                    <label class="radio-custom-label not-allowed" style="margin-top: 0px">
                      {{ "Every" | translate }}
                      <select id="cronHourIncrementIncrement" style="width: 50px" formControlName="WeekEveryWeek">
                        <option value="{{ day }}" *ngFor="let day of cronDowWeeksArr">{{ day }}</option>
                      </select>
                      {{ "Week(s)  on" | translate }}
                      <div style="margin-top: 10px">
                        <div class="row row-cols-lg-auto g-3 align-items-center">
                          <span class="col-sm-1" style="margin-right: 25px" *ngFor="let obj of cronDowDaysStartArr">
                            <input class="form-check-input" name="cronDowSpecificSpecific" type="checkbox" [checked]="obj.checked" (change)="getCheckedWeekDays(obj, $event)" />
                            <label class="form-check-label" style="margin-left: 16px">{{ obj.name }}</label>
                          </span>
                        </div>
                      </div>

                      <div style="margin-top: 10px">
                        {{ "at" | translate }}

                        <select id="SelecthourOnHOurbasis" formControlName="WeekEveryStartTime" style="width: 100px">
                          <option value="{{ hour }}" *ngFor="let hour of twentyFourhourFormatArr">{{ hour }}</option>
                        </select>
                      </div>
                    </label>
                  </div>

                  <div style="margin-left: 20px" class="">
                    <label class="radio-custom-label not-allowed"> Send <input style="width: 50px" type="number" maxlength="2" formControlName="reportDays" /> {{ "Day Report" | translate }} </label>
                  </div>
                  <div class="sentence-previewx">
                    {{ "Every " | translate }} {{ cronForm.controls["WeekEveryWeek"].value }} {{ "Week on" | translate }} {{ selectedWeekDays }} {{ "at" | translate }} {{ cronForm.controls["WeekEveryStartTime"].value }} {{ "hours," | translate }} {{ "send " }}
                    {{ cronForm.controls["reportDays"].value }} {{ "day report. " }}
                  </div>
                </div>
              </div>
              <div class="row mx-0 mt-2 mb-1">
                <div style="display: flex; position: fixed; gap: 4rem">
                  <div style="position: relative">
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="assignedGroup1" [ngModelOptions]="{ standalone: true }" (change)="getGroupSubStatus(assignedGroup1)" placeholder="{{ 'Recipient' | translate }}" list="personnal1" />
                    <div class="dropdown-parent" style="position: absolute; top: 0; right: 0">
                      <a href="javascript:void(0)" class="availableBtn txt-light-gog">
                        <i class="fas fa-chevron-down cursor-p ml-10" *ngIf="selectGroupArr1.length > 0" id="dropdown-id1" (click)="showMore1 = !showMore1"></i>
                      </a>
                      <div class="dropdown-panel bg-white-mode" *ngIf="showMore1 && selectGroupArr1.length > 0" style="width: 280px">
                        <ul class="list-unstyled mb-0">
                          <li *ngFor="let obj of selectGroupArr1" class="position-relative">
                            {{ obj }}
                            <span class="text-danger font-14 position-absolute" style="right: 8px; cursor: pointer" (click)="removeGroup1(obj); $event.stopPropagation()" title="{{ 'Delete' | translate }}"> &#10005; </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <datalist id="personnal1">
                      <option *ngFor="let item of productionGroupList | sortAlpha : 'name'" [value]="item.name">{{ item.name }}</option>
                    </datalist>
                  </div>
                  <div>
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="selectedQuickFilter" [ngModelOptions]="{ standalone: true }" (change)="onQuickFilterChange(selectedQuickFilter)" placeholder="{{ 'Quick Filter' | translate }}" list="quickFilterList" />
                    <datalist id="quickFilterList">
                      <option *ngFor="let filter of quickFilterArr" [value]="filter.filterName">{{ filter.filterName }}</option>
                    </datalist>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon>date_range</mat-icon>
                {{ "Month" | translate }}
              </ng-template>
              <div class="row mx-0 mt-2">
                <div class="input-row">
                  <div style="margin-left: 20px">
                    <label class="radio-custom-label not-allowed">
                      {{ "Every" | translate }}
                      <select id="cronHourIncrementIncrement" style="width: 50px" formControlName="MonthEveryMonth">
                        <option value="{{ month.val }}" *ngFor="let month of cronEveryMonthArr">{{ month.val }}</option>
                      </select>
                      {{ "month(s)" | translate }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mx-0">
                <div class="input-row">
                  <div style="margin-left: 20px">
                    <label class="radio-custom-label not-allowed">
                      {{ "On the" | translate }}
                      <select id="cronHourIncrementIncrement" style="width: 50px" formControlName="MonthOnDate">
                        <option value="{{ month }}" *ngFor="let month of cronMonthsArr">{{ month }}</option>
                      </select>
                      {{ "at" | translate }}
                      <select id="SelecthourOnHOurbasis" style="width: 100px" formControlName="MonthStartTime">
                        <option value="{{ hour }}" *ngFor="let hour of twentyFourhourFormatArr">{{ hour }}</option>
                      </select>
                    </label>
                  </div>
                  <div style="margin-left: 20px" class="">
                    <label class="radio-custom-label not-allowed"> Send <input style="width: 50px" type="number" maxlength="2" formControlName="reportDays" /> {{ "Day Report" | translate }} </label>
                  </div>
                  <div class="sentence-previewx">
                    {{ "Every " | translate }} {{ cronForm.controls["MonthEveryMonth"].value }} {{ "month on" | translate }} {{ cronForm.controls["MonthOnDate"].value }} {{ "at" | translate }} {{ cronForm.controls["MonthStartTime"].value }} {{ "hours," | translate }} {{ "send " }}
                    {{ cronForm.controls["reportDays"].value }} {{ "day report. " }}
                  </div>
                </div>
              </div>
              <div class="row mx-0 mt-2 mb-1">
                <div style="display: flex; position: fixed; gap: 4rem">
                  <div style="position: relative">
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="assignedGroup1" [ngModelOptions]="{ standalone: true }" (change)="getGroupSubStatus(assignedGroup1)" placeholder="{{ 'Recipient' | translate }}" list="personnal1" />
                    <div class="dropdown-parent" style="position: absolute; top: 0; right: 0">
                      <a href="javascript:void(0)" class="availableBtn txt-light-gog">
                        <i class="fas fa-chevron-down cursor-p ml-10" *ngIf="selectGroupArr1.length > 0" id="dropdown-id1" (click)="showMore1 = !showMore1"></i>
                      </a>
                      <div class="dropdown-panel bg-white-mode" *ngIf="showMore1 && selectGroupArr1.length > 0" style="width: 280px">
                        <ul class="list-unstyled mb-0">
                          <li *ngFor="let obj of selectGroupArr1" class="position-relative">
                            {{ obj }}
                            <span class="text-danger font-14 position-absolute" style="right: 8px; cursor: pointer" (click)="removeGroup1(obj); $event.stopPropagation()" title="{{ 'Delete' | translate }}"> &#10005; </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <datalist id="personnal1">
                      <option *ngFor="let item of productionGroupList | sortAlpha : 'name'" [value]="item.name">{{ item.name }}</option>
                    </datalist>
                  </div>
                  <div>
                    <input type="text" class="form-control border-left-0 border-right-0 border-top-0" [(ngModel)]="selectedQuickFilter" [ngModelOptions]="{ standalone: true }" (change)="onQuickFilterChange(selectedQuickFilter)" placeholder="{{ 'Quick Filter' | translate }}" list="quickFilterList" />
                    <datalist id="quickFilterList">
                      <option *ngFor="let filter of quickFilterArr" [value]="filter.filterName">{{ filter.filterName }}</option>
                    </datalist>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <div class="modal-footer p-4">
          <button class="btn btn-first mb-4 font-12 text-uppercas" *ngIf="selectGroupArr1.length > 0" (click)="setCronExpressionTest()">
            {{ "Test Now" | translate }}
          </button>
          <button class="btn btn-first ml-3 mb-4 font-12 text-uppercase" style="background-color: '#10B981'" data-dismiss="modal" (click)="setCronExpression()">
            {{ "Save" | translate }}
          </button>
        </div>
        <div class="time-card-modal p-4" *ngIf="runningJobObj?.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="cursor-p">Job Name</th>
                <th class="cursor-p">Filter</th>
                <th class="cursor-p">Job Expression</th>
                <th class="cursor-p">Recipients</th>
                <th class="cursor-p">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let job of runningJobObj; let i = index">
                <td>{{ job.actionType }}</td>
                <td>{{ job.filterName }}</td>
                <td>{{ job.cronExpression }}</td>
                <td style="position: relative">
                  <span>{{ job.recipient[0] }}</span>
                  <div class="dropdown-parent" style="display: inline-block; margin-left: 10px">
                    <a href="javascript:void(0)" class="availableBtn txt-light-gog">
                      <i class="fas fa-chevron-down cursor-p" *ngIf="job.recipient.length > 1" (click)="toggleRecipientDropdown(i)"> </i>
                    </a>
                    <div class="dropdown-panel bg-white-mode" *ngIf="expandedRecipientIndex === i" style="position: absolute; background: white; border: 1px solid #ccc; z-index: 10; padding: 10px">
                      <ul class="list-unstyled mb-0">
                        <li *ngFor="let recipient of job.recipient">{{ recipient }}</li>
                      </ul>
                    </div>
                  </div>
                </td>

                <td>
                  <button class="btn btn-first mb-4 font-12 text-uppercase" style="background-color: #dc3545" (click)="removeJob(job)">
                    {{ "Remove" | translate }}
                  </button>
                  <button class="btn btn-first ml-3 mb-4 font-12 text-uppercase" (click)="resumeJob(job)">
                    {{ "Resume" | translate }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
</div>
